import { render } from "./MobileMenu.vue?vue&type=template&id=0400ba68&scoped=true&ts=true"
import script from "./MobileMenu.vue?vue&type=script&lang=ts"
export * from "./MobileMenu.vue?vue&type=script&lang=ts"

import "./MobileMenu.vue?vue&type=style&index=0&id=0400ba68&scoped=true&lang=css"

import exportComponent from "C:\\Users\\benja\\Desktop\\Renault\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0400ba68"]])

export default __exports__